<div class="content-box_module__333d9 content-box_lg__3v3a-">
  <header _ngcontent-bps-c143="" class="content-box_header__xPnGx clearfix">
    <div _ngcontent-bps-c143="" class="wil-float-left">
      <h4 _ngcontent-bps-c143="" class="content-box_title__1gBHS">
        <span _ngcontent-bps-c143="">Favorite Jobs</span>
      </h4>
    </div>
  </header>

  <div class="content-box_body__3tSRB">
    <div class="jobsearch-typo-wrap">
      <div class="jobsearch-candidate-savedjobs">
        <table>
          <thead>
            <tr>
              <th>Job Title</th>
              <th>Company</th>
              <th>Posted Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let job of favoriteJobs; let index = index">
              <td>
                <a class="jobsearch-savedjobs-thumb" [routerLink]="['/jobs/details/', job.job_slug]"><img
                    [src]="getUserProfilePicture(job)"></a>
                <h2 class="jobsearch-pst-title"><a [routerLink]="['/jobs/details/', job.job_slug]">{{job.job_title}}</a>
                </h2>
              </td>
              <td><span>@ {{job.employer_display_name}}</span></td>
              <td>{{job.job_created_at | date:'MMMM d, yyyy'}}</td>
              <td>
                <a (click)="deleteFavoriteJob(job, index)" class="jobsearch-savedjobs-links jobsearch-delete-fav-job"><i
                    class="jobsearch-icon jobsearch-rubbish"></i></a>
                <a [routerLink]="['/jobs/details/', job.job_slug]" class="jobsearch-savedjobs-links"><i
                    class="jobsearch-icon jobsearch-view"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
